import React from "react";

import {
    Autocomplete,
    AutocompleteRenderInputParams,
    FormControl,
    FormHelperText,
    TextField,
} from "@mui/material";

import {
    Controller
} from "react-hook-form";

import {
    alpha,
    Theme,
} from "@mui/material/styles";

import {
    withStyles
} from "@mui/styles";

import { 
  getAutocompleteError,
  commonErrorParameters 
} from "commons/fields/fields";

const ITEM_HEIGHT = 48;

export interface ZPlayAutocompleteProps
{
	fieldName: string,
	label: string,
	data: { id: string, value: string }[],
    disabledOption?: { id: string, value: string }[],
	control: any,
	trigger: any,
	formState: any,
	disabled?: boolean,
	required?: boolean,
	onChange?: (contentName: string) => string,
}

export interface ZPlayAutocompleteState
{
	data: string[]
}

const styles = (theme: Theme) => ({
    root: {
        "& .MuiFilledInput-root": {
            overflow: "hidden",
            borderRadius: "0px",
            backgroundColor: "#FFFFFF",
            transition: theme.transitions.create([
                "border-color",
                "background-color",
                "box-shadow",
            ]),
            "&:hover": { backgroundColor: "#FFFFFF", },
            "&.Mui-focused": {
                backgroundColor: "#FFFFFF",
                boxShadow: `${alpha("#000000", 0.25)} 0 0 0 2px`,
                borderColor: "#000000",
            }
        }
    }
});

class ZPlayAutocomplete extends React.Component<ZPlayAutocompleteProps, ZPlayAutocompleteState>
{
    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
        };
    }

    public componentDidMount() {
        this.loadData();
    }

    private loadData = (): void => {

        let data = [];

        for (let item of this.props.data) {
            data.push(item.id);
        }

        this.setState({ data: data });
    };

		private getLabel = (id: string) : string => {

				for (let item of this.props.data) {
						if(item.id === id){
							return item.value
						}
				}

				return ""
		}

    render() {

        let error = getAutocompleteError(this.props.formState, this.props.fieldName);

        return (<Controller
            name={this.props.fieldName}
            control={this.props.control}
            render={({ field }) => (<Autocomplete
                {...field}
                disablePortal
                disabled={this.props.disabled || this.state.data.length === 0}
                options={this.state.data}
                autoHighlight
                getOptionLabel={(option) => `${this.getLabel(option)}`}
                getOptionDisabled={(option) => {
                    return this.props.disabledOption?.some((item) => item.id === option) || false;
                }}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(_, value) => {
                    const newValue = this.props.onChange?.(value as string) || value;
                    field.onChange(newValue);
                    this.props.trigger(this.props.fieldName);
                }}
                ListboxProps={{ style: { maxHeight: ITEM_HEIGHT * 4.5 } }}
                renderInput={(params: AutocompleteRenderInputParams) => (<FormControl
                    fullWidth
                    error={Boolean(error)}
                    required={this.props.required || false}
                    disabled={this.props.disabled || this.props.formState.isSubmitting || this.state.data.length === 0}
                    ref={params.InputProps.ref}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                        {params.InputProps.startAdornment}
                        <TextField
                            id={params.id}
                            sx={{ flex: 1 }}
                            name={this.props.fieldName}
                            label={this.props.label}
                            required={this.props.required || false}
                            disabled={this.props.disabled || this.props.formState.isSubmitting || this.state.data.length === 0}
                            size="small"
                            variant="filled"
														{...commonErrorParameters(this.props.fieldName, this.props.formState)}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                        />
                        {params.InputProps.endAdornment}
                    </div>
                    <FormHelperText sx={{ marginLeft: 0 }}>{error?.message}</FormHelperText>
                </FormControl>)}
            />)}
        />);
    }
}

export default withStyles(styles)(ZPlayAutocomplete);
